module.exports = __webpack_public_path__ + "static/ABA_2021-Finalist__COMMERCIAL BROKER OF THE YEAR-43f86728dc31bf328b87de48ca203baa.png";